export default __webpack_public_path__ + "static/media/forging.ff486359.png";